module.exports = __webpack_public_path__ + "media/application/images/svgs/type-8565bf294dfaad8392737f9bb6028ba6.svg";